import { render, staticRenderFns } from "./IpsTooltip.vue?vue&type=template&id=06636b42&scoped=true&"
import script from "./IpsTooltip.vue?vue&type=script&lang=js&"
export * from "./IpsTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06636b42",
  null
  
)

export default component.exports